import { combineEpics } from 'redux-observable'
import { tasksLoad } from './tasks'
import { getErrorAction } from './errorMapper'
import { redirectToError } from './redirectToError'
import { createReducer } from './reducerUtils'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Actions
export const BOARD_DEF_LOAD = 'BOARD_DEF_LOAD'
export const BOARD_DEF_LOAD_SUCCESS = 'BOARD_DEF_LOAD_SUCCESS'
export const BOARD_DEF_LOAD_FAILURE = 'BOARD_DEF_LOAD_FAILURE'
export const BOARD_DEF_SET = 'BOARD_DEF_SET'
export const BOARD_DEF_SET_SUCCESS = 'BOARD_DEF_SET_SUCCESS'
export const BOARD_DEF_SET_FAILURE = 'BOARD_DEF_SET_FAILURE'

// Action Creators
export const boardDefLoad = projectId => ({ type: BOARD_DEF_LOAD, payload: projectId })
export const boardDefLoadSuccess = payload => ({ type: BOARD_DEF_LOAD_SUCCESS, payload })
export const boardDefLoadFailure = payload => ({ type: BOARD_DEF_LOAD_FAILURE, payload, error: true })
export const boardDefSet = (payload) => ({ type: BOARD_DEF_SET, payload: { boardDefId: payload } })
export const boardDefSetSuccess = () => ({ type: BOARD_DEF_SET_SUCCESS, payload: {} })
export const boardDefSetFailure = (payload) => ({ type: BOARD_DEF_SET_FAILURE, payload, error: true })


// Epics
export const boardDefLoadEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(BOARD_DEF_LOAD),
    mergeMap(action =>
      vapiClient.getBoardDef(action.payload).pipe(
        map(ajaxResponse => boardDefLoadSuccess(ajaxResponse.response)),
        catchError(error => of(getErrorAction(error, boardDefLoadFailure)))
      )
    )
  )

export const boardDefLoadFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(BOARD_DEF_LOAD_FAILURE),
    map(action => redirectToError())
  )

export const boardDefSetEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(BOARD_DEF_SET),
    mergeMap(action =>
      vapiClient.setBoardDef(
        state$.value.project.id,
        action.payload.boardDefId
      ).pipe(
        map(() => boardDefSetSuccess()),
        catchError(error => of(getErrorAction(error, boardDefSetFailure)))
      )
    )
  )

export const boardDefSetSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(BOARD_DEF_SET_SUCCESS),
    map(() => tasksLoad(state$.value.project.id))
  )

export const boardDefEpics = combineEpics(
  boardDefLoadEpic,
  boardDefLoadFailureEpic,
  boardDefSetEpic,
  boardDefSetSuccessEpic
)

// Reducer
const boardDefLoadSuccessReducer = (state, { id }) => id
const boardDefSetReducer = (state, { boardDefId }) => boardDefId

const boardDefHandlerMapping = {
  [BOARD_DEF_LOAD_SUCCESS]: boardDefLoadSuccessReducer,
  [BOARD_DEF_SET]: boardDefSetReducer
}

const boardDefInitialState = ''
export const boardDefReducer = createReducer(boardDefInitialState, boardDefHandlerMapping)

export default boardDefReducer



// WEBPACK FOOTER //
// ./src/store/boardDef.js